import { createContext, useContext } from 'react';

import type { GenericPostDetailProps } from '@/features/posts/components/detail/GenericPostDetailView';

const PostContext = createContext<GenericPostDetailProps | undefined>(
  undefined
);

export const usePostCard = () => {
  const context = useContext(PostContext);
  if (!context) {
    throw new Error('usePost must be used within PostContext.Provider');
  }
  return context;
};

export const PostProvider = PostContext.Provider;
